import { Checkbox, ComboBox, Dropdown, TooltipHost } from '@fluentui/react'
import ClearIcon from '../../../../components/SVGComponents/ClearIcon';
import React, { useCallback, useEffect, useState } from 'react'
import CustomToolTipHost from '../../../../components/CustomToolTipHost/CustomToolTipHost';
import { getEnv } from '../../../../helpers/EnvHelper';

const AutoAssignModalitySubModality = (props) => {

    const [subModalityList, setSubModalityList] = useState([]);
    const [selectedSubModality, setSelectedSubModality] = useState([]);
    
    const handleSubModalityCheckBoxClick = (e, selection) =>{
        
        let modWithSubModlist = props.selectedModalityAndSubModality.filter((m)=>m.modalityId==props.modality.id);
        let subModList = modWithSubModlist[0].subModalities.map((m)=>m);
        // console.log(typeof subModList);
        if(selection.selected){
            if(!subModList.includes(selection.key)){
                subModList.push(selection.key);
            }
        }else{
            subModList = subModList.filter(m => m!=selection.key);
        }
        props.setSelectedModalityAndSubModality((prev)=>{
            let list = prev;
            return list.map((m)=>{
                if(m.modalityId==props.modality.id){
                    return {modalityId:m.modalityId, subModalities:subModList}
                }else{
                    return m;
                }
            })
        });
        setSelectedSubModality(subModList);
    }

    const handleClearButtonForSubMod = useCallback(() => {
        props.setSelectedModalityAndSubModality((prev)=>{
            let list = prev;
            return list.map((m)=>{
                if(m.modalityId==props.modality.id){
                    return {modalityId:m.modalityId, subModalities:[]}
                }else{
                    return m;
                }
            })
        });
        setSelectedSubModality([]);
      });

    useEffect(()=>{ 
        // console.log(props.selectedModalityAndSubModality);
        let subModalityList = [];
        props.selectedModalityAndSubModality.map((m)=>{
            if(m.modalityId==props.modality.id){
                subModalityList = m.subModalities;
            }
        });
        setSelectedSubModality(subModalityList);
    },[props.selectedModalityAndSubModality])

    const handleModalityCheckBoxClick = ( e, isChecked, modalityId) =>{
        if(isChecked){
            let list2 = [];
            if(props.modality.subModality.length > 0){
                props.modality.subModality.forEach((element)=>{
                    list2.push(element.id);
                });
            }
            let list1 = [...props.selectedModalityAndSubModality, {modalityId:modalityId,subModalities:list2}];
            props.setSelectedModalityAndSubModality(list1);
            setSelectedSubModality(list2);
            props.setSelectedModality((prev)=>{
                prev.push(modalityId);
                return prev;
            });
        }else{
            let list1 = props.selectedModalityAndSubModality.filter(m => m.modalityId!=modalityId);
            props.setSelectedModalityAndSubModality(list1);
            setSelectedSubModality([]);
            props.setSelectedModality(list1.map((m)=>m.modalityId));
        }
    }


    useEffect(()=>{
        formatSubModalityList();
    },[]);

    function formatSubModalityList (){
        let list1 = [];
        props.modality.subModality.forEach((element)=>{
          list1.push({key:element.id,text:element.serviceCode + ": "+ element.serviceName})
        })
        setSubModalityList(list1);
    }

    const dropDownStyle = {
        dropdown: {
          width: "100%"
        },
        dropdownItemSelected: {
          fontSize: "12px",
          lineHeight: "18px",
          fontWeight: "600",
        },
        dropdownItemsWrapper: {
          maxHeight: "300px"
        },
        dropdownItem: {
          fontSize: "12px",
          lineHeight: "18px",
          fontWeight: "600",
          color: "white"
        },
      };

    const customStyles = {
        // Note that this is actually the wrapper of the input and caret (doesn't include the label)
        optionText:{   
            textWrap: "wrap",
        },
        label:{
            alignItems:"flex-start"
        },
      };
    return (
    <>
        <div key={props.index} className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4" style={{display:"flex"}}>
            <div className="ms-sm8 ms-md4 ms-lg3 ms-xl3" style={{ display: "block",whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis"}}>
                <Checkbox
                key={props.modality.id}
                label={props.modality.name}
                name={props.modality.name}
                onChange={(e, isChecked) => handleModalityCheckBoxClick(e,isChecked,props.modality.id)}
                checked={props.selectedModality.includes(props.modality.id)}
                />
            </div>
            {getEnv("REACT_APP_VDC_PLATFORM") == "true" && props.selectedModality.includes(props.modality.id) && subModalityList?.length > 0 && 
            <div className="modal-scroll" style={{ display: "flex", alignItems: "center",color:"white" }}>
                <div className="ms-sm12 ms-md8 ms-lg6 ms-xl10">
                    <ComboBox
                    comboBoxOptionStyles={customStyles}
                    calloutProps={{ doNotLayer: true }}
                    placeholder="Select Sub Modality"
                    multiSelect
                    selectedKey={selectedSubModality}//selectedSubModality
                    options={subModalityList}
                    onChange={(e, selection) => handleSubModalityCheckBoxClick(e, selection)}
                    />
                </div>
                <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" onClick={() => handleClearButtonForSubMod()} style={{ paddingLeft: "5px" }}>
                    <CustomToolTipHost content="Clear">
                        <ClearIcon></ClearIcon>
                    </CustomToolTipHost>
                </div>
            </div>}
          </div>
    </>
  )
}

export default AutoAssignModalitySubModality
